
import { defineComponent } from 'vue';
import TheProfessionalDocumentGrid
  from '@/views/professional/documents/TheProfessionalDocumentGrid.vue';
import TheProfessionalDocumentList
  from '@/views/professional/documents/TheProfessionalDocumentList.vue';
import VButton from '@/components/vendor/basic/button/VButton.vue';
import api from '@/api';
import { mapState } from 'vuex';
import Media from '@/api/objects/Media';

export default defineComponent({
  name: 'TheProfessionalDocument',
  components: {
    VButton,
    TheProfessionalDocumentGrid,
    TheProfessionalDocumentList,
  },
  data() {
    return {
      typeSelected: 'all',
      media: [] as Media[],
      status: 'loading',
    };
  },
  computed: {
    ...mapState('expedient', ['currentExpedient']),
    ...mapState('app', ['formsSettings']),
  },
  watch: {
    typeSelected(newValue) {
      this.formsSettings.uploaded_media_category_options.forEach((type: any) => {
        if (type.key === newValue) {
          this.loadExpedientMedia();
        }
      });
    },
  },
  async mounted() {
    await this.loadExpedientMedia();
  },
  methods: {
    async loadExpedientMedia() {
      try {
        this.status = 'loading';

        const filters = {
          media_type: this.typeSelected,
        };

        this.media = await api.professional.expedients.media.all(this.currentExpedient.id, filters);

        this.status = 'loaded';
      } catch (e) {
        this.$toast.error(this.$t('Ha ocurrido un error al cargar los documentos'));
        this.status = 'loaded';
      }
    },
  },
});
